import { action, makeAutoObservable, observable } from "mobx"
import { Option } from "polaris-enhance"

import APILabelFee from "@/api/labelFee"
import APIPlan from "@/api/plan"
import {
  benefitInforProps,
  ConfirmModalConfig,
  default as ICommonStore,
  IToastProps,
  PopupSaveBtnType,
} from "@/models/ICommon"
import { ValueOf } from "@/utils/types-utils"

type CalculateRateModelSource = "approveModal" | "approveDrawer"

export default class CommonStore {
  @observable globalLoading: boolean = false
  @observable fullScreenLoading = true // 开发时给false 后期修改回来
  @observable feedBackShow = false
  @observable show: boolean = true // 是否显示 POST 消息
  @observable showCount: number = 0 // post 展示次数
  @observable showCommentModal = false // 是否展示评价弹窗
  @observable handleClickShowMessage = true // 是否响应 click 事件弹窗聊天对话框
  @observable isCannyLoaded = false
  @observable isError = false // 保存错误状态
  @observable drawShow = true // 首页抽屉是否打开
  @observable subscribeGuideRefresh = false // 订阅引导是否请求
  @observable popupSaveBtn = {
    active: false,
    loading: false,
    disabled: false,
  }
  // 存放店铺套餐权限
  @observable subscribeBenefitList: benefitInforProps | null = null
  // 用于存放confirmModal的信息
  @observable confirmModalConfig: ConfirmModalConfig | null = null
  @observable calculateRateModel: boolean = false // 费率弹窗状态
  @observable calculateRateModelSource: CalculateRateModelSource | null = null
  // @observable isSubscribeGuide: number = 5 // 是否订阅引导 (大于5是不需要订阅)
  @observable selectDateTime: any = {
    dashboard: {
      day: 30,
      updated_at_min: undefined,
      updated_at_max: undefined,
    },
    analytics: {
      day: 30,
      updated_at_min: undefined,
      updated_at_max: undefined,
    },
  }

  @observable temporarySchemas: any = undefined
  @action.bound
  setTemporarySchemas(val: any) {
    this.temporarySchemas = val
  }

  @observable temporarySchemaFormLoading: boolean = false
  @action.bound
  setTemporarySchemaFormLoading(val: boolean) {
    this.temporarySchemaFormLoading = val
  }

  @action.bound
  async setTemporarySchemaFormDynamic(cb: () => Promise<any>) {
    this.setTemporarySchemaFormLoading(true)
    try {
      const res = await cb()
      if (res) {
        this.setTemporarySchemaForm(res)
      }
    } catch (error) {
      console.log(error)
    }
    this.setTemporarySchemaFormLoading(false)
  }

  @action.bound
  async updateAuthority() {
    const res = await APIPlan.getStoreAuthority()
    if (res && res.code === 1000 && res.data) {
      this.setSubscribeBenefit({
        ...res.data,
      })
    }
  }

  @observable temporarySchemaForm: any = undefined
  @action.bound
  setTemporarySchemaForm(val: any) {
    this.temporarySchemaForm = val
  }

  @action.bound
  setConfirmModalConfig(val: ConfirmModalConfig | null) {
    this.confirmModalConfig = val
  }
  constructor() {
    makeAutoObservable(this)
  }

  @action.bound
  setSubscribeGuideRefresh(value: boolean) {
    this.subscribeGuideRefresh = value
  }

  @action.bound
  setDrawShow(value: boolean) {
    this.drawShow = value
  }

  @action.bound
  public setShowCount(count: number) {
    this.showCount = count
  }

  @action.bound
  public setIsCannyLoaded(value: boolean) {
    this.isCannyLoaded = value
  }

  @action.bound
  public setShowCommentModal(data: boolean): void {
    this.showCommentModal = data
  }

  @action.bound
  public setPostShow(data: boolean): void {
    // 将要弹出 Post 时检测是否有会话弹出
    if (
      data &&
      document.querySelector(
        "#intercom-container iframe.intercom-borderless-frame",
      )
    ) {
      return
    }
    this.show = data
  }

  @action.bound
  setFeedBackShow(value: boolean) {
    this.feedBackShow = value
  }

  @action.bound
  public setFullScreenLoading(loading: boolean) {
    this.fullScreenLoading = loading
  }

  @observable toastInfo: any | null = null

  @action.bound
  addToast(toastProps: IToastProps): void {
    this.toastInfo = {
      ...toastProps,
      onDismiss: () => {
        this.toastInfo = null
      },
    }
  }

  @action.bound
  setPopupSaveBtn(key: keyof PopupSaveBtnType, val: ValueOf<PopupSaveBtnType>) {
    this.popupSaveBtn[key] = Boolean(val)
  }

  @action.bound
  setGlobalLoading(loading: boolean) {
    this.globalLoading = loading
  }

  @action.bound
  setErrorState(isError: boolean) {
    this.isError = isError
  }

  // 店铺套餐权限设值
  @action.bound
  setSubscribeBenefit(benefitInfor: benefitInforProps): void {
    this.subscribeBenefitList = benefitInfor
  }
  // 设置费率值
  @action.bound
  setCalculateRateModel(val: boolean, source?: CalculateRateModelSource) {
    this.calculateRateModel = val
    this.calculateRateModelSource = val ? (source ?? null) : null
  }
  @action.bound
  setSelectDateTime(key, value) {
    this.selectDateTime[key] = value
  }
  // 设置是否订阅引导
  // @action.bound
  // setIsSubscribeGuide(val: number) {
  //   this.isSubscribeGuide = val
  // }

  @observable countryOptions: Option[] = []
  @action.bound
  setCountryOptions(val: Option[]) {
    this.countryOptions = val
  }
  @action.bound
  async getCountryOptions() {
    const res = await APILabelFee.getMarketCountryOptions({ id: -1 })
    if (res.code === 1000 && res.data) {
      const data = res.data.map((item) => ({
        label: item.name,
        value: item.code,
      }))
      this.setCountryOptions(data)
    }
  }
}
